import React, { useContext, useEffect, useState, createRef } from 'react';
import Navbar from '../../components/navbar';
import Settings from '../../components/settings';
import { ReactComponent as Send } from '../../assets/send.svg';
import './style.scss';
import { Context } from '../../store';
import axios from 'axios';
import Loader from '../../components/loader';
import io from 'socket.io-client';
import '../../components/message/style.scss';
import { SOCKETURL } from '../../components/network';

let socket;
// let token;

const Global = (props) => {
  const { state, dispatch } = useContext(Context);
  const msgRef = createRef();
  const [loading, setLoading] = useState(false);
  const [chat, setChat] = useState(false);
  const ChatScroll = createRef();
  // eslint-disable-next-line no-unused-vars

  //   const preCheck = async () => {
  //     if (!localStorage.getItem('copy-user')) {
  //       props.history.push('/login');
  //     } else {
  //       token =
  //         JSON.parse(localStorage.getItem('copy-user')).token || state.token;
  //       const data = await axios.post(`${BACKURL}/auth`, { token });
  //       // const data = await axios.post('http://192.168.0.104:4000/auth', {
  //       //   token,
  //       // });
  //       if (data.data.done) {
  //         getChat();
  //         setLoading(true);
  //       } else {
  //         localStorage.removeItem('copy-user');
  //         props.history.push('/login');
  //       }
  //     }
  //   };
  // console.log(2);
  const getChat = async () => {
    const data = await axios(`${SOCKETURL}/history`);
    setChat(data.data);
    setLoading(true);
  };

  // console.log(chat);
  useEffect(() => {
    // console.log(state);
    if (state.logged) {
      return (window.location.href = '/global');
    }
    if (!state.username) {
      dispatch({
        type: 'SET_USER_DATA',
        payload: {
          username: 'Guest#' + (Math.floor(Math.random() * 1000) + 1000),
          userImg:
            'https://avataaars.io/?avatarStyle=Circle&topType=Hat&accessoriesType=Blank&facialHairType=Blank&clotheType=BlazerShirt&eyeType=Happy&eyebrowType=Default&mouthType=Smile&skinColor=Tanned',
          globalColor: 'grey',
        },
      });
      window.location.reload();
    }
    getChat();
    socket = io(SOCKETURL, {
      reconnectionDelay: 2500,
    });
    // socket = io(`http://localhost:4040/`, {
    //   reconnectionDelay: 2500,
    // });
    // console.log(state.globalColor);
    socket.emit(
      'join',
      {
        token: 'global',
        userImg: state.userImg,
        username: state.username,
        globalColor: state.globalColor,
        userToken: state.username,
      },
      () => {},
    );
    // socket.emit('globalAdd', {
    //   token: 'global',
    //   username: state.username,
    //   userImg: state.userImg,
    // });
    // return socket.disconnect();
    return () => {
      if (socket.connect) socket.close();
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  //   useEffect(() => {
  //     socket.on('message', (message) => {
  //       const userDiv = document.createElement('div');
  //       userDiv.innerHTML = `<div class='txt-message user'>
  //       <div class='txt-des'>
  //         ${message.message}
  //         <span>${new Date().toLocaleTimeString()}</span>
  //       </div>
  //       <img src=${state.userImg} alt='' />
  //     </div>`;
  //       document.getElementById('display-section').appendChild(userDiv);
  //       document.getElementById('display-section').scrollBy(0, 100);
  //     });
  //     // eslint-disable-next-line react-hooks/exhaustive-deps
  //   }, []);
  useEffect(() => {
    socket.on('globalMessage', (message) => {
      // console.log(message);
      if (message.message === `${state.username} just landed to Global!`) {
        return;
      }
      const aiDiv = document.createElement('div');
      aiDiv.innerHTML = `<div class='txt-message ${
        message.userToken === state.username ? 'user' : 'ai'
      }' style='${
        message.userToken === state.username
          ? `flex-direction : row-reverse;
      justify-content: end;`
          : null
      }' >
        <img
          src=${message.userImg}
          alt=''
          id='profile-image'
        />
        <div class='txt-des'>
        <b style='color:${message.globalColor}'>${message.username}</b>
          ${message.message}
          <span>${new Date().toLocaleTimeString()}</span>
        </div>
      </div>`;
      document.getElementById('display-section').appendChild(aiDiv);

      document.getElementById('display-section').scrollBy(0, 100);
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // const getData = async (msg) => {
  //   try {
  //     document.getElementById('display-section').scrollBy(0, 500);
  //   } catch (err) {
  //     console.log(err);
  //   }
  // };
  useEffect(() => {
    if (ChatScroll.current) {
      var c = ChatScroll.current;
      c.scrollTop = c.scrollHeight;
    }
  }, [ChatScroll]);
  const onSend = async (txt) => {
    // if (!socket.connect) {
    //   socket = io(SOCKETURL, {
    //     reconnectionDelay: 2500,
    //   });
    //   socket.emit(
    //     'join',
    //     { token: 'global', userImg: state.userImg, username: state.username, },
    //     () => {},
    //   );
    //   getChat();
    // }
    if (msgRef.current.value !== '') {
      socket.emit(
        'global',
        {
          token: 'global',
          message: txt,
          userImg: state.userImg,
          username: state.username,
          globalColor: state.globalColor,
          userToken: state.username,
          time: Date.now(),
        },
        () => {},
      );
      // getData(txt);
    }
  };

  return (
    <div className='main-wrapper'>
      {loading ? (
        <>
          <Navbar props={props} />
          <div className='main-container'>
            <div className='main-side'>
              <Settings props={props} />
            </div>
            <div className='main-box'>
              <div className='message-box'>
                <div className='display-section'>
                  <div
                    className='display-container'
                    id='display-section'
                    ref={ChatScroll}>
                    {/* <AiText
                      text='Hey Welcome Back!'
                      time={new Date().toLocaleTimeString()}
                    /> */}
                    {chat
                      ? chat.map((i, indx) => {
                          return (
                            <>
                              {chat[indx - 1] &&
                              new Date(parseInt(i.time)).toDateString() ===
                                new Date(
                                  parseInt(chat[indx - 1].time),
                                ).toDateString() ? null : new Date(
                                  parseInt(i.time),
                                ).toDateString() ===
                                new Date().toDateString() ? (
                                <div className='time'>
                                  <hr color='#333' />
                                  <span>Today</span>
                                </div>
                              ) : (
                                <div className='time'>
                                  <hr color='#333' />
                                  <span>
                                    {new Date(parseInt(i.time)).toDateString()}
                                  </span>
                                </div>
                              )}
                              <div
                                key={indx}
                                className={
                                  i.userToken === state.username
                                    ? 'txt-message user'
                                    : 'txt-message ai'
                                }
                                style={
                                  i.userToken === state.username
                                    ? {
                                        flexDirection: ' row-reverse',
                                        justifyContent: 'end',
                                      }
                                    : null
                                }>
                                <img
                                  src={i.userImg}
                                  alt=''
                                  id='profile-image'
                                />
                                <div className='txt-des'>
                                  <b style={{ color: i.globalColor }}>
                                    {i.username}
                                  </b>
                                  {i.message}
                                  <span>
                                    {i.time
                                      ? new Date(
                                          parseInt(i.time),
                                        ).toLocaleTimeString()
                                      : null}
                                  </span>
                                </div>
                              </div>
                            </>
                          );
                        })
                      : loading}
                  </div>
                </div>
                <div className='txt-section'>
                  <textarea
                    ref={msgRef}
                    id='msg-input'
                    maxLength='100'
                    // onChange={(e) => console.log(e)}
                    placeholder='Enter Your Message'
                    onKeyDown={(e) => {
                      if (e.key === 'Enter') {
                        if (e.target.value.trim() !== '') {
                          onSend(e.target.value.trim());
                          e.target.value = ''.trim();
                          e.preventDefault();
                        }
                      }
                    }}
                  />
                  <div
                    className='send-btn'
                    onClick={() => {
                      // const value = document.getElementById('msg=input');
                      onSend(msgRef.current.value.trim());
                      msgRef.current.value = ''.trim();
                      // msgRef.current.preventDefault();
                    }}>
                    <Send />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </>
      ) : (
        <Loader />
      )}
    </div>
  );
};

export default Global;
